import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import { Toaster } from "@/components/ui/sonner";
import { PWAInstallProvider } from "@/hooks/usePWAInstall";
import { IOSInstallModal } from "@/components/InstallButton";
import InstallBanner from "@/components/InstallBanner";
import UpdateBanner from "@/components/UpdateBanner";

function App() {
  useEffect(() => {
    // Note: service worker is registered inside <UpdateBanner /> via
    // useAppUpdate() so we can watch for upgrades and surface a reload prompt.

    // Pause CSS animations when the tab/PWA is hidden (saves CPU on iOS)
    const onVisibility = () => {
      document.body.classList.toggle("rrz-hidden", document.hidden);
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, []);

  return (
    <PWAInstallProvider>
      <div className="App">
        <InstallBanner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <IOSInstallModal />
        <UpdateBanner />
        <Toaster theme="dark" position="bottom-center" />
      </div>
    </PWAInstallProvider>
  );
}

export default App;
